import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { OrbitLoaderComponent } from "../../utils/orbitLoader";
import { getEmployeeMonthlyStatus } from "../../services/apiService";
import "./EmployeeSubPage.css";

const MonthlyStatus = () => {
  const [monthlyData, setMonthlyData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
  const userId =
    userInfo.user_id || parseInt(localStorage.getItem("userId") || "0");

  useEffect(() => {
    const fetchMonthlyStatus = async () => {
      try {
        setLoading(true);
        const data = await getEmployeeMonthlyStatus(userId);
        setMonthlyData(data);
        setLoading(false);
      } catch (error) {
        console.error("Aylık durum çekilemedi:", error.message);
        setError(error.message);
        setLoading(false);
      }
    };
    if (userId && userId !== 0) {
      fetchMonthlyStatus();
    } else {
      setError("Kullanıcı ID bulunamadı");
      setLoading(false);
    }
  }, [userId]);

  const goBack = () => {
    navigate("/employee");
  };

  if (loading) {
    return (
      <div className="loading-container">
        <OrbitLoaderComponent size="medium" showPath={true} />
        <p className="loading-text">Yükleniyor...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="employee-subpage">
        <div className="employee-container">
          <div className="subpage-header">
            <h2>Aylık Durumum</h2>
          </div>
          <div className="error-message">
            <i className="fas fa-exclamation-triangle"></i>
            <p>Hata: {error}</p>
            <button
              className="retry-button"
              onClick={() => window.location.reload()}
            >
              Yeniden Dene
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="employee-subpage">
      <div className="employee-container">
        <div className="subpage-header">
          <h2>Aylık Durumum</h2>
        </div>
        <div className="content-area">
          {Object.keys(monthlyData).length > 0 ? (
            <>
              <div className="stats-grid">
                <div className="stat-card primary">
                  <div className="stat-label">Toplam Çalışma Saati</div>
                  <div className="stat-value">
                    {monthlyData.total_hours || 0} saat
                  </div>
                </div>
                <div className="stat-card success">
                  <div className="stat-label">İşe Geliş Sayısı</div>
                  <div className="stat-value">
                    {monthlyData.present_days || 0} gün
                  </div>
                </div>
                <div className="stat-card warning">
                  <div className="stat-label">Geciken Gün Sayısı</div>
                  <div className="stat-value">
                    {monthlyData.late_days || 0} gün
                  </div>
                </div>
                <div className="stat-card danger">
                  <div className="stat-label">Devamsızlık Sayısı</div>
                  <div className="stat-value">
                    {monthlyData.absent_days || 0} gün
                  </div>
                </div>
              </div>
              <div className="monthly-status-container">
                <div className="monthly-status-header">
                  <h3 className="monthly-status-title">
                    <i className="fas fa-chart-line"></i>
                    Aylık Detaylar
                  </h3>
                </div>
                <div className="content-area">
                  <table className="modern-table">
                    <tbody>
                      <tr>
                        <td>
                          <strong>Ortalama Günlük Çalışma Süresi</strong>
                        </td>
                        <td>{monthlyData.avg_daily_hours || 0} saat</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Fazla Mesai</strong>
                        </td>
                        <td>{monthlyData.overtime_hours || 0} saat</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>İzin Sayısı</strong>
                        </td>
                        <td>{monthlyData.leave_days || 0} gün</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          ) : (
            <div className="no-data">
              <i className="fas fa-calendar-alt"></i>
              <p>Aylık durum verisi bulunamadı.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MonthlyStatus;
